export default "__VITE_ASSET__5cd52679__"